module.exports = __webpack_public_path__ + "media/images/adverts/google_ads-eea18a9687ce6e4405b978c8f9056041.jpg";